import React, { useEffect, useState } from 'react'
import FormInput from '../../../atoms/FormInput/FormInput'
import FormRadio from '../../../atoms/FormRadio/FormRadio'
import FormSelect from '../../../atoms/FormSelect/FormSelect'
import ArticoliSenzaStampa from '../../../molecules/ArticoliSenzaStampa/ArticoliSenzaStampa'
import ArticoliPersonalizzati from '../../../molecules/ArticoliPersonalizzati/ArticoliPersonalizzati'
import { useDispatch, useSelector } from 'react-redux'
import { Button, FormField, Tooltip } from '../../../atoms'
import useCreateOffertaUtils from '../../../../hooks/useCreaOffertaUtils'
import LoadingSvg from '../../../atoms/Loading/Loading'
import { useRouter } from 'next/router'
import useTrans from '../../../../hooks/useTrans'
import { priceNotation } from '../../../../utils/safe'
import { Info } from '../../../atoms/NewIcons'
import _ from 'lodash'

const MarkupPrezzi = ({ formik, setStep, carrello }) => {
  const router = useRouter()
  const t = useTrans()
  const { markupFields, fetchMarkup, loading } = useCreateOffertaUtils()
  const { type, tipologiaMarkup, totale_quotazione, articoli, totale_imponibile_carrello } = useSelector(
    (state) => state?.creaofferta
  )
  const dispatch = useDispatch()

  useEffect( () => {
    !router?.query?.editing && _.isEmpty(articoli) &&
      fetchMarkup().then((markups) => {
        dispatch({
          type: 'INIT_ARTICOLI',
          payload: { carrello: carrello, markupFields: markups },
        })
        dispatch({ type: 'CONFERMA_TOTALE' })
      })
  }, [])

  return loading ? (
    <LoadingSvg />
  ) : (
    <div>
      <div className="markup-prezzo__radio__container">
        <div className="markup-prezzo__radio__item">
          <FormRadio
            label={t('Applica un markup sul prezzo totale del carrello')}
            checked={tipologiaMarkup === 'sul_totale'}
            onClick={() => {
              dispatch({
                type: 'CHANGE_TIPOLOGIA_MARKUP',
                payload: { tipologia: 'sul_totale' },
              })
            }}
          ></FormRadio>

          {tipologiaMarkup === 'sul_totale' && <MarkupPrezzo global carrello={carrello} />}
        </div>

        <FormRadio
          label={t('Applica un markup separato per singolo prodotto,personalizzazione,trasporto')}
          checked={tipologiaMarkup === 'sul_singolo'}
          onClick={() => {
            dispatch({
              type: 'CHANGE_TIPOLOGIA_MARKUP',
              payload: { tipologia: 'sul_singolo' },
            })
          }}
        />
      </div>
      <Articoli carrello={carrello} tipoMarkup={tipologiaMarkup} articoli={articoli} />

      <AltriCostiMarkup
        type={type}
        formik={formik}
        carrello={carrello}
      />
      <div className="markup-prezzo__totale">
        <Button
          variant="primary"
          onClick={() => {
            dispatch({ type: 'CONFERMA_TOTALE' })
            setStep((prev) => prev + 1)
          }}
          label={t('Conferma markup')}
        />
        <div className="markup-prezzo__totale__wrapper">
          <div className="markup-prezzo__totale__label" style={{ fontWeight: 'normal' }}>
            <div className="markup-prezzo__totale__label--with-icon">
              <span>{t('Totale Imponibile carrello')}: </span>
              <Tooltip
                label={t(
                  "L'importo comprende gli eventuali sconti e spese di spedizione"
                )}
              >
                <Info width={16} />
              </Tooltip>
            </div>
            <p>{priceNotation(totale_imponibile_carrello, 2)} €</p>
          </div>
          <div className="markup-prezzo__totale__label">
            <p>{t('Totale Quotazione')}: </p>
            <p>{priceNotation(totale_quotazione, 2)} €</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MarkupPrezzi

export const Articoli = ({ carrello, tipoMarkup, articoli, preview }) => {
  const TotaleQuotazionePreview = !!(typeof preview === 'function')
  return (
    <div>
      <ArticoliSenzaStampa
        carrelloMain={carrello}
        righe={carrello?.righe_carrello_merce_neutra}
        creaOfferta={{
          tipoMarkup: tipoMarkup,
          margineInput: TotaleQuotazionePreview
            ? null
            : tipoMarkup === 'sul_totale'
            ? null
            : MarkupPrezzo,
          totaleQuotazione: (codice) =>
            tipoMarkup === 'sul_totale'
              ? null
              : priceNotation(parseFloat(articoli?.[codice]?.totale_riga), 2) + ' €' || null,
          preview: preview,
        }}
      />

      <ArticoliPersonalizzati
        creaOfferta={{
          tipoMarkup: tipoMarkup,
          margineInput: TotaleQuotazionePreview
            ? null
            : tipoMarkup === 'sul_totale'
            ? null
            : MarkupPrezzo,
          totaleQuotazione: (codice) =>
            tipoMarkup === 'sul_totale'
              ? null
              : priceNotation(parseFloat(articoli?.[codice]?.totale_riga), 2) + ' €' || null,
          preview: preview,
        }}
        carrelloMain={carrello}
        righe={carrello?.personalizzazioni_carrello ? carrello.personalizzazioni_carrello : []}
      />
    </div>
  )
}

const AltriCostiMarkup = ({ carrello }) => {
  const { altri_costi, tipologiaMarkup } = useSelector((state) => state?.creaofferta)
  const dispatch = useDispatch()
  const t = useTrans()
  const fields = [
    { field: 'impianti', label: 'Impianti', field_carrello: 'valore_impianto', field_carrello_moltiplicatore: 'numero_impianti' },
    { field: 'gestione', label: 'Avviamento', field_carrello: 'valore_gestione', field_carrello_moltiplicatore: '' },
    { field: 'tracciatura', label: 'Tracciatura', field_carrello: 'valore_tracciatura_logo', field_carrello_moltiplicatore: 'numero_tracciature_logo' },
  ]
  return (
    <div className="markup-prezzo__altri-costi">
      <div className="markup-prezzo__altri-costi__heading">
        <p>{t('Altri costi')} </p>
      </div>

      {/* // ? Trasporto viene gestito come valore assoluto */}
      <div className="markup-prezzo__altri-costi__item">
        <p className="markup-prezzo__altri-costi__label">
          {t(
            'Trasporto (inserisci il valore che vuoi addebitare al tuo cliente per la spedizione)'
          )}
        </p>
        <div className="markup-prezzo__input">
          <div className="markup-prezzo__input__text">
            <FormField>
              <FormInput
                placeholder={'0'}
                type="number"
                value={altri_costi['trasporto']?.totale_riga || null}
                onChange={(e) =>
                  dispatch({
                    type: 'CHANGE_MARKUP_ALTRI_COSTI',
                    payload: { value: e.target.value, field: 'trasporto' },
                  })
                }
              />
            </FormField>
          </div>
          <div className="markup-prezzo__input__select">
            <p style={{ alignSelf: 'center' }}>€</p>
          </div>
        </div>
      </div>

      {/* // ! Tutti i campi che hanno bisogno di markup */}
      {fields?.map(({ field, label, field_carrello, field_carrello_moltiplicatore }) => (
        <div className="markup-prezzo__altri-costi__item">
          <p className="markup-prezzo__altri-costi__label">{t(label)}</p>
          {tipologiaMarkup !== 'sul_totale' && (
            <div className="markup-prezzo__wrapper">
              <div className="markup-prezzo__wrapper__p">
                <p>{carrello?.[field_carrello]}</p>
              </div>
              <div className="markup-prezzo__input">
                <div className="markup-prezzo__input__text">
                  <FormField>
                    <FormInput
                      placeholder={'0'}
                      type="number"
                      value={altri_costi[field]?.markup || null}
                      onChange={(e) =>
                        dispatch({
                          type: 'CHANGE_MARKUP_RIGA_ALTRI_COSTI',
                          payload: {
                            markup: e.target.value,
                            field: field,
                            totale_riga: carrello?.[field_carrello],
                            moltiplicatore: field_carrello_moltiplicatore
                              ? carrello?.[field_carrello_moltiplicatore]
                              : carrello?.[field_carrello] > 0
                              ? 1
                              : 0,
                          },
                        })
                      }
                    />
                  </FormField>
                </div>
                <div className="markup-prezzo__input__select">
                  <FormField>
                    <FormSelect
                      placeholder={altri_costi[field]?.type || '€'}
                      options={[
                        { label: '€', value: '€' },
                        { label: '%', value: '%' },
                      ]}
                      onChange={(e) =>
                        dispatch?.({
                          type: 'CHANGE_TYPE_RIGA_ALTRI_COSTI',
                          payload: {
                            field: field,
                            type: e.target.value,
                            totale_riga: carrello?.[field_carrello],
                            moltiplicatore: field_carrello_moltiplicatore
                              ? carrello?.[field_carrello_moltiplicatore]
                              : carrello?.[field_carrello] > 0
                              ? 1
                              : 0,
                          },
                        })
                      }
                    />
                  </FormField>
                </div>
              </div>

              <div className="markup-prezzo__wrapper__p">
                <p> {altri_costi[field]?.totale_riga || carrello?.[field_carrello]} </p>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

export function MarkupPrezzo({ codice, global, totale, carrello, rigaId, personalizzazioneId }) {
  const { articoli, markup } = useSelector((state) => state?.creaofferta)
  const dispatch = useDispatch()
  const t = useTrans()
  return (
    <div className="markup-prezzo__input">
      <div className="markup-prezzo__input__text">
        <FormField>
          <FormInput
            placeholder="0"
            value={global ? markup : articoli?.[codice + (personalizzazioneId ? `_${personalizzazioneId}` : "")]?.value || ''}
            type="number"
            onChange={(e) =>
              dispatch?.({
                type: global ? 'CHANGE_MARKUP' : 'CHANGE_MARKUP_RIGA',
                payload: global
                  ? { value: e?.target?.value }
                  : { codice: codice + (personalizzazioneId ? `_${personalizzazioneId}` : ""), value: e?.target?.value, totale: totale, rigaId: rigaId },
              })
            }
          />
        </FormField>
      </div>
      <div className="markup-prezzo__input__select">
        <FormField>
          <FormSelect
            placeholder={'%'}
            options={[
              { label: '%', value: '%' },
              { label: '€', value: '€' },
            ]}
            onChange={(e) =>
              dispatch?.({
                type: global ? 'CHANGE_TYPE' : 'CHANGE_TYPE_RIGA',
                payload: global
                  ? { type: e.target.value }
                  : { codice: codice + (personalizzazioneId ? `_${personalizzazioneId}` : ""), type: e.target.value, totale: totale, rigaId: rigaId },
              })
            }
          />
        </FormField>
      </div>
    </div>
  )
}
